import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default function ReviewSection({ id, dark, children }) {
  const ref = useRef(null);

  useEffect(() => {
    const sec = ref.current;
    if (!sec) return;
    ScrollTrigger.create({
      trigger: sec, start: 'top 82%',
      onEnter() {
        const f = sec.querySelectorAll('.reveal-fade');
        const c = sec.querySelectorAll('.reveal-clip');
        const u = sec.querySelectorAll('.reveal-up');
        if(f.length) gsap.to(f, { opacity:1, duration:.7, stagger:.1, ease:'power3.out' });
        if(c.length) gsap.to(c, { opacity:1, y:0, duration:.85, stagger:.09, ease:'power3.out', delay:.1 });
        if(u.length) gsap.to(u, { opacity:1, y:0, duration:.7, stagger:.09, ease:'power3.out', delay:.18 });
      }
    });
  }, []);

  return (
    <section ref={ref} className={`rs${dark ? ' rs-dark' : ''}`} id={id}>
      {children}
    </section>
  );
}
